import React from 'react';

import type { EmptyDirectoryCardProps } from './types';

import { VStack } from '@/components/ui/vstack';

/**
 * EmptyDirectoryCard - Placeholder for grid layout filling
 *
 * Used to fill incomplete rows in multi-column layouts
 */
export const EmptyDirectoryCard = React.memo(function EmptyDirectoryCard(
  _props: EmptyDirectoryCardProps
) {
  return <VStack className="flex-1" />;
});
